import styled from "styled-components";

import { fonts } from "../shared";

export const Item = styled.li`
    display: block;
    ${fonts.typeScale[14]};
    color: ${fonts.fontColors.light.primary};
`;
